/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

export default setToArray;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_setToArray.js
// module id = 1313
// module chunks = 0